import React from "react";
import { cn } from "@/lib/utils";

export function IconTile({
  icon: Icon,
  size = 40,
  iconSize = 20,
  color = "teal-400",
  bg = "slate-800",
  rounded = "lg",
  className = "",
}: {
  icon: React.ElementType;
  size?: number;
  iconSize?: number;
  color?: string;
  bg?: string;
  rounded?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-lg bg-slate-800",
        size === 32 && "w-8 h-8",
        size === 40 && "w-10 h-10", 
        size === 48 && "w-12 h-12",
        size === 56 && "w-14 h-14",
        size === 64 && "w-16 h-16",
        rounded === "md" && "rounded-md",
        rounded === "lg" && "rounded-lg",
        rounded === "xl" && "rounded-xl",
        rounded === "full" && "rounded-full",
        bg === "slate-700" && "bg-slate-700",
        bg === "slate-800" && "bg-slate-800",
        bg === "slate-900" && "bg-slate-900",
        bg === "teal-500/20" && "bg-teal-500/20",
        bg === "blue-500/20" && "bg-blue-500/20",
        bg === "transparent" && "bg-transparent",
        className
      )}
    >
      <Icon 
        className={cn(
          "text-teal-400",
          iconSize === 16 && "w-4 h-4",
          iconSize === 20 && "w-5 h-5",
          iconSize === 24 && "w-6 h-6", 
          iconSize === 28 && "w-7 h-7",
          iconSize === 32 && "w-8 h-8",
          color === "teal-400" && "text-teal-400",
          color === "blue-400" && "text-blue-400",
          color === "green-400" && "text-green-400",
          color === "slate-400" && "text-slate-400",
          color === "cyan-400" && "text-cyan-400",
          color === "orange-400" && "text-orange-400",
          color === "purple" && "text-purple",
          color === "red-400" && "text-red-400",
          color === "yellow-400" && "text-yellow-400"
        )} 
      />
    </div>
  );
}